import type { RequiredGeneric } from '@pba/utils';
import { useTranslation } from 'react-i18next';
import { Fieldset, Flex, Form, Radio, Text } from 'ui';

export type BadgeNotificationFormContentValues = {
  badgeNotificationsSettings: { enableNotifications: boolean };
};

const BadgeNotificationFormContent = <T extends BadgeNotificationFormContentValues = never>(_: RequiredGeneric<T>) => {
  const { t } = useTranslation();

  return (
    <Fieldset legend={{ title: 'Badge Notifications', visible: false }}>
      <Flex gap={8} vertical>
        <Text size="small" type="title" uppercase weight="medium">
          Badge Notifications
        </Text>

        <Form.Item<BadgeNotificationFormContentValues>
          name={['badgeNotificationsSettings', 'enableNotifications']}
          rules={[{ required: true }]}
        >
          <Radio.Group>
            <Radio value>{t('On')}</Radio>
            <Radio value={false}>{t('Off')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Flex>
    </Fieldset>
  );
};

export default BadgeNotificationFormContent;
